import React, { Component } from 'react'
import './Styles/Notfound.css'
export class NotFound extends Component {
  render() {
    return (
      <div className='nf-main'>
        <h1 className='nf-h1'>ERROR: 404</h1>
        <p className='nf-p'>Opps we ran into a problem</p>
      </div>
    )
  }
}

export default NotFound